import React, {PropsWithChildren} from 'react'
import {MapMarkerProps} from '../map/types'
import { useMapComponent } from '../map/components/hooks'

const MapMarker: React.FC<PropsWithChildren<MapMarkerProps>> = props => {
  const MapComponent = useMapComponent<MapMarkerProps>('YMapMarker')
  // aalebedev-6. пропс draggable не реактивен
  const {draggable} = props
  return MapComponent && <MapComponent key={String(draggable)} {...props} />
}

export default MapMarker
